import type { Resource } from '../../';
export const product_group_girls: Resource = {"default":"Girls'"};
